/** Days until delivery (negative: overdue), counted in calendar days from `today`. */
export function daysToDelivery(deliveryDate, today = new Date()) {
    const [y, m, d] = deliveryDate.slice(0, 10).split('-').map(Number);
    const due = Date.UTC(y, m - 1, d);
    const now = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return Math.round((due - now) / 86400000);
}
/** How a delivery date reads on a to-do list: 逾期 3 天 / 今天交 / 明天交 / 11月20日交. */
export function deliveryLabel(deliveryDate, today = new Date()) {
    const days = daysToDelivery(deliveryDate, today);
    const [, m, d] = deliveryDate.slice(0, 10).split('-').map(Number);
    if (days < 0)
        return { text: `逾期 ${-days} 天`, tone: 'late' };
    if (days === 0)
        return { text: '今天交', tone: 'today' };
    if (days === 1)
        return { text: '明天交', tone: 'soon' };
    return { text: `${m}月${d}日交`, tone: 'later' };
}
